import { period, randomId } from "../shared";
import type { ExpensePeriod, ExpenseReportStatus } from "../shared";

interface InvalidCustomerFields {
  customerCrmId: string;
  name: string;
  invalidFields: string[];
}

interface InvalidInformation {
  awaitingExpenseReportList?: number[];
  companyCustomer?: InvalidCustomerFields;
  invalidBeneficiary?: { customerCrmId: string; expenseIds: string[] };
  kycNotPassed?: boolean;
  missingReimbursementRates?: {
    locationId: number;
    locationName: string;
    cdrEndDates: string[];
  }[];
  recipientList?: InvalidCustomerFields[];
  supplierCustomer?: InvalidCustomerFields;
}

interface ExpenseReportSummary {
  currency?: string | null;
  emailAddressList?: string[];
  id: number;
  invalidInformation?: InvalidInformation;
  period: ExpensePeriod;
  totalAmountInCents: number;
  totalConsumptionInWattHours: number;
  companyName: string;
  status: ExpenseReportStatus;
}

function generateMockExpenseReport({
  id = randomId(),
  ...overrides
}: Partial<ExpenseReportSummary> = {}): ExpenseReportSummary {
  return {
    id,
    companyName: `Fleet ${String(id).padStart(3, "0")} A/S`,
    period: period(2026, 6),
    status: "Pending",
    currency: "DKK",
    totalAmountInCents: 100_000,
    totalConsumptionInWattHours: 500_000,
    ...overrides,
  };
}

export { generateMockExpenseReport };
export type { ExpenseReportSummary, InvalidCustomerFields, InvalidInformation };
